import { refresh } from './refresh.interceptor';
import { setToken } from './setToken.interceptor';

export const interceptors = {
  setToken,
  refresh,
};
